import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const UmbrellaIcon = ({
  color = 'foraBlue',
  width = 19,
  marginLeft,
  marginRight,
  containerSize,
}: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 19">
      <path
        fill={getSemanticTextColor(color)}
        fillRule="evenodd"
        d="M9.869 10.509v5.65c0 1.364-1.108 2.472-2.471 2.472-1.362 0-2.471-1.108-2.471-2.471 0-.47.38-.85.85-.85s.85.38.85.85c0 .425.346.77.77.77.426 0 .772-.345.772-.77v-5.651h1.7zm-.85-9.51c4.662 0 8.498 3.515 9.019 8.037H-.002C.52 4.514 4.356 1 9.02 1z"
      />
    </svg>
  </DefaultIconWrapper>
);
